module.exports = {
  "124304": {
    "name": "Standard Letterhead",
    "templates": [
      ...[334163, 334164, 334165, 334166].map((id) => ({
        id,
        "seq": 1,
        "name": "WRE Letterhead – 1 Agent",
        "templatePage": "front",
        "product": {
            "name": "8.5x11 Letterhead",
            "flatHeight": "11.000",
            "flatWidth": "8.500",
            "finishedHeight": "11.000",
            "finishedWidth": "8.500",
            "isPickPack": true
        },
        "images": {
            "4": {
                "url": "https://picsum.photos/seed/k2ws1/200/300",
            }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
    })),



      {
        "id": 366160,
        "seq": 2,
        "name": "WRE Letterhead - Office",
        "templatePage": "front",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366160.jpg"
          }
        },
        "description": "AA Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
      },

      {
        "id": 366192,
        "seq": 3,
        "name": "WRE Letterhead - Blank 2nd Sheet",
        "templatePage": "both",
        "product": {
          "name": "Inventory - Manufactured",
          "flatHeight": "0.000",
          "flatWidth": "0.000",
          "finishedHeight": "0.000",
          "finishedWidth": "0.000"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366192.jpg"
          }
        },
        "description": "Manufactured & Inventoried",
        "sideReversed": false
      },
      {
        "id": 366741,
        "seq": 4,
        "name": "WRE Letterhead - 2 Agent + Team Name",
        "templatePage": "both",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366741.jpg"
          }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
      },
      {
        "id": 366742,
        "seq": 5,
        "name": "WRE Letterhead -  2 Agent",
        "templatePage": "both",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366742.jpg"
          }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
      }




    ]
  },
  "124308": {
    "name": "Commercial Letterhead",
    "templates": [
      {
        "id": 366159,
        "seq": 1,
        "name": "Commercial Letterhead - Agent",
        "templatePage": "front",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366159.jpg"
          }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
      },
      {
        "id": 366162,
        "seq": 2,
        "name": "Commercial Letterhead - Office",
        "templatePage": "front",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366162.jpg"
          }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
      }
    ]
  },
  "124309": {
    "name": "Property Management Letterhead",
    "templates": [
      {
        "id": 366158,
        "seq": 1,
        "name": "WPM Letterhead - Agent",
        "templatePage": "front",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366158.jpg"
          }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
      },
      {
        "id": 366161,
        "seq": 2,
        "name": "WPM Letterhead - Office",
        "templatePage": "front",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366161.jpg"
          }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false
      }
    ]
  },
  "124491": {
    "name": "Foundation",
    "templates": [
      {
        "id": 366672,
        "seq": 1,
        "name": "Windermere Foundation Letterhead",
        "templatePage": "front",
        "product": {
          "name": "8.5x11 Letterhead",
          "flatHeight": "11.000",
          "flatWidth": "8.500",
          "finishedHeight": "11.000",
          "finishedWidth": "8.500"
        },
        "images": {
          "4": {
            "url": "https://assets.awsdev.xpressdocs.com/dserv/tpl/large/1/366672.jpg"
          }
        },
        "description": "Be sure your correspondence reinforces your brand with 8.5” x 11” letterhead. Customize your design to display your brand on letters, memos, offers, and more.",
        "sideReversed": false,
        "proofEngineType": 0,
//        "proofEngineType": 7,
      }
    ]
  }
}